import { useEffect, useState } from 'react';
import { basic, validationMessages } from '../../../config/validations';
import { useForm } from "react-hook-form";
import { Grid, TextField } from '@material-ui/core';
import { handleSnackBar, setReRender, invokePostService, invokeGetService, setFocusElement, toggleRightDrawer } from '../../../store/global/actions';
import { useDispatch } from 'react-redux';
import { useHistory } from "react-router-dom";
import { getDetailsFromUrl } from '../../../services/blueprint'
import CreatableSelectBox from '../../atoms/CreatableSelectBox/CreatableSelectBox';



export default function CreateSimulation({ onClose, setTabActive, tabActive }) {

    const dispatch = useDispatch();
    const history = useHistory();
    const { register,control, handleSubmit, formState: { errors }, watch, setValue, reset, setError } = useForm();
    const [simulationInfo, setSimulationInfo] = useState({});
    const [isCreating, setIsCreating] = useState(false);
    const [selectedTransactions, setSelectedTransactions] = useState([]);
    const [isFetching, setIsFetching] = useState(false);
    const [selectedDelegates, setSelectedDelegates] = useState([]);
    const [transactions, setTransactions] = useState([]);
    const [simulationsList, setSimulationsList] = useState([])

    const messages = {
        ...validationMessages,
    }

    const onSimulationNext = async ({ name, description, scenario }) => {
        console.log({name,description,scenario});
        
        if(!name){
            setError('name',{
                types: 'error',
                message: 'Name field is required',
                shouldFocus: 'name'
            })
            return true
        }

        const response = await dispatch(invokePostService('checkScenarioExistence',{simulationName: name, scenario}))
        if(response.status){
            if(response.data.isExist){
                dispatch(handleSnackBar({open: true,message: response.message, severity: "error"}));
                return false;
            }
        }
        setSimulationInfo({ name, description,scenario });
        setValue('name', name);
        setValue('description', description);
        setValue('scenario', scenario)
        reset({ name, description, scenario })
        setTabActive('transaction');
    }

    

    const onTransactionNext = () => {
        if (selectedTransactions.length < 1) {
            const validateError = document.getElementById("transaction-validation-error");
            if (validateError === null) {
                document.getElementById(`simulation[simulation][0][transaction]`)?.insertAdjacentHTML("afterend", `<p id="transaction-validation-error" class="text text-danger validation-error" >Please select transaction</p>`);
            }
            return;
        } else {
            const validateError = document.getElementById("transaction-validation-error");
            if (validateError) {
                validateError.remove();
            }
        }
        setTabActive('delegate');
    }

    const onTransactionBack = () => {
        setTabActive("simulationInfo");
    }

    const onDelegateBack = () => {
        setTabActive("transaction");
    }

    const onCreate = () => {
        if (selectedDelegates.length < 1) {
            dispatch(handleSnackBar({ open: true, message: 'Must select delegate to create simulation', severity: 'error' }));
            return;
        }
        setIsCreating(true);
        const simulation = {
            name: simulationInfo.name,
            scenario: simulationInfo.scenario,
            description: simulationInfo.description,
            transactions: selectedTransactions,
            delegates: selectedDelegates.map(delegate => delegate._id)
        };
        dispatch(invokePostService('createSimulation', { simulation }, [])).then(response => {
            setIsCreating(false);
            if (response.status && response.data !== null) {
                const { slug, blueprintId } = getDetailsFromUrl();
                history.push(`/blueprint/${slug}/${blueprintId}/simulation/${response.data?.simulation?._id}`);
                dispatch(toggleRightDrawer());
                dispatch(setFocusElement({}));
                dispatch(handleSnackBar({ open: true, message: response.message, severity: 'success' }));
                dispatch(setReRender());
            } else {
                if (response?.code === process.env.REACT_APP_FORM_ERROR_CODE) {
                    setTabActive("simulationInfo");
                    response?.errors?.forEach(error => {
                        setError(error.name, { message: error.message });
                    });
                } else if (response?.message) {
                    dispatch(handleSnackBar({ open: true, message: response.message, severity: 'error' }))
                }
            }
        });
    }


    const fetchSimulationList = async () => {
        const response = await dispatch(invokeGetService('listSimulations',{}));
        const data = response.data;
        const simList = [];
        if(data?.length > 0){
            data.forEach((item) => simList.push({title: item.name, inputValue: item.name}));
        }
        setSimulationsList(simList);
    }

    useEffect(() => {
        fetchSimulationList();
    },[])

    console.log({errors});

    return (
        <Grid container direction={"row"} spacing={3}>

            {tabActive == 'simulationInfo' &&
                <>
                    <Grid item xs={12}>
                        <CreatableSelectBox 
                            inputRef={register({ ...basic })}
                            optionList={simulationsList}
                            name='name'
                            label='Name'
                            control={control}
                            createButtonPrefix='Create new testcase'
                            required
                            errors={errors}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            name="scenario"
                            id="scenario"
                            fullWidth
                            type={"text"}
                            required={true}
                            label={"Scenario"}
                            variant="outlined"
                            placeholder={""}
                            inputRef={register({ ...basic })}
                            error={errors?.scenario ? true : false}
                            // helperText={errors?.name ? messages[errors?.name?.type] : ''}
                            helperText={errors?.scenario ? errors?.scenario?.message ? errors.scenario.message : messages[errors?.scenario?.type] : ''}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            type={"text"}
                            fullWidth
                            multiline={true}
                            rows={4}
                            label={"Description"}
                            variant="outlined"
                            name="description"
                            inputRef={register({ required: false })}
                        />
                    </Grid>
                </>
            }

            {/* {tabActive == 'transaction' &&
                <Grid item xs={12} style={{ minHeight: "60vh" }}>
                    <TransactionSelector transactions={transactions} selectedTransactions={selectedTransactions} setSelectedTransactions={setSelectedTransactions} isFetching={isFetching} setIsFetching={setIsFetching} />
                </Grid>
            }
            {tabActive == 'delegate' &&
                <Grid item xs={12} style={{ minHeight: "60vh" }}>
                    <DelegateSelector selectedTransactions={selectedTransactions} isFetching={isFetching} setIsFetching={setIsFetching} setSelectedDelegates={setSelectedDelegates} selectedDelegates={selectedDelegates} />
                </Grid>
            } */}

            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginBottom: 20 }} >
                {/* {tabActive == 'simulationInfo' && <NextCancel onNext={handleSubmit(onSimulationNext)} onCancel={onClose} disableNext={isFetching} content={'Next'} />} */}
                {/* {tabActive == 'transaction' && <NextPrevious onNext={onTransactionNext} onPrevious={onTransactionBack} nextDisable={isFetching} />} */}
                {/* {tabActive == 'delegate' && <CreateBack onCreate={onCreate} onBack={onDelegateBack} createDisable={isCreating || isFetching} content={isCreating ? 'Creating..' : 'Create'} />} */}
            </Grid>

        </Grid >
    )
}